// The scheduler endpoint lives on the legacy backend (app.smartrate.it),
// not the main API host (api.smartrate.it) used by VUE_APP_API_URL.
const SCHEDULER_API_URL =
  process.env.VUE_APP_SCHEDULER_API_URL || 'https://app.smartrate.it/api';
const API_BASE_URL = `${SCHEDULER_API_URL}/calculations/scheduler`;

interface ProgressiveLiquidityPayload {
  action: string;
  calculationData: any;
  formData: any;
  useSafetyMargin: boolean;
}

export const calculateProgressiveLiquidity = async (payload: ProgressiveLiquidityPayload): Promise<any> => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorBody = await response.text();
      console.error('API Error Response:', errorBody);
      throw new Error(`La richiesta al pianificatore di liquidità è fallita con stato: ${response.status}`);
    }

    const data = await response.json();

    if (data.error) {
        throw new Error(`Errore dall'API di pianificazione: ${data.message || data.error}`);
    }

    return data;
  } catch (error) {
    console.error('Errore durante la chiamata a calculateProgressiveLiquidity:', error);
    throw error;
  }
};
